// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"styles_Wrapper__OahYp","Container":"styles_Container__idtKH","Button":"styles_Button__XzX5j"};